import { render, staticRenderFns } from "./layoutItem.vue?vue&type=template&id=2ee3245e&scoped=true&"
import script from "./layoutItem.vue?vue&type=script&lang=js&"
export * from "./layoutItem.vue?vue&type=script&lang=js&"
import style0 from "./layoutItem.vue?vue&type=style&index=0&id=2ee3245e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3245e",
  null
  
)

export default component.exports